import React from 'react';
import './App.css';
import Progress from './Progress';

function App() {
  return (
    <div className="App">
      <Progress></Progress>
    </div>
  );
}

export default App;
